(function () {
  'use strict';

  if (window.__bundlePromoGiftsInitialized) return;
  window.__bundlePromoGiftsInitialized = true;

  function getPromoConfig() {
    var config = document.getElementById('BundlePromoConfig');

    if (!config) {
      console.warn(
        '[Bundle Promo Gifts] BundlePromoConfig was not found.'
      );
      return null;
    }

    try {
      var promos = JSON.parse(config.textContent || '[]');

      if (!Array.isArray(promos)) {
        throw new Error('BundlePromoConfig must contain an array.');
      }

      return promos;
    } catch (error) {
      console.error(
        '[Bundle Promo Gifts] Could not parse BundlePromoConfig.',
        error
      );

      return null;
    }
  }

  var PROMOS = getPromoConfig();

  if (!PROMOS) return;

  var isReconciling = false;
  var reconcileTimer = null;
  var lastCart = null;

  var dismissedGiftStorageKey =
    'bundlePromoDismissedGiftVariants';

  function getDismissedGiftVariantIds() {
    try {
      return JSON.parse(
        window.sessionStorage.getItem(
          dismissedGiftStorageKey
        ) || '[]'
      );
    } catch (error) {
      return [];
    }
  }

  function setDismissedGiftVariantIds(variantIds) {
    try {
      window.sessionStorage.setItem(
        dismissedGiftStorageKey,
        JSON.stringify(variantIds)
      );
    } catch (error) {}
  }

  function dismissGiftVariant(variantId) {
    var dismissed =
      getDismissedGiftVariantIds();

    var numericVariantId =
      Number(variantId);

    if (
      dismissed.indexOf(
        numericVariantId
      ) !== -1
    ) {
      return;
    }

    dismissed.push(
      numericVariantId
    );

    setDismissedGiftVariantIds(
      dismissed
    );
  }

  function clearDismissedGiftVariants() {
    setDismissedGiftVariantIds([]);
  }

  function isActivePromo(promo) {
    if (
      !promo ||
      promo.enabled !== true
    ) {
      return false;
    }

    var now = Date.now();

    var start = promo.startsAt
      ? Date.parse(promo.startsAt)
      : null;

    var end = promo.endsAt
      ? Date.parse(promo.endsAt)
      : null;

    if (
      promo.startsAt &&
      Number.isNaN(start)
    ) {
      return false;
    }

    if (
      promo.endsAt &&
      Number.isNaN(end)
    ) {
      return false;
    }

    if (
      start &&
      now < start
    ) {
      return false;
    }

    if (
      end &&
      now > end
    ) {
      return false;
    }

    return true;
  }

  function cartHasAnyHandle(
    cart,
    handles
  ) {
    if (!Array.isArray(handles)) {
      return false;
    }

    return cart.items.some(
      function (item) {
        return (
          handles.indexOf(
            item.handle
          ) !== -1
        );
      }
    );
  }

  function getActivePromos(cart) {
    return PROMOS.filter(
      function (promo) {
        if (
          !isActivePromo(promo)
        ) {
          return false;
        }

        return cartHasAnyHandle(
          cart,
          promo.triggerProductHandles ||
            []
        );
      }
    );
  }

  function getAutoGiftLines(cart) {
    return cart.items.filter(
      function (item) {
        return (
          item.properties &&
          item.properties
            ._bundle_promo_gift
        );
      }
    );
  }

  function getPromoGiftLines(
    cart,
    promo,
    variantId
  ) {
    return cart.items.filter(
      function (item) {
        return (
          Number(item.variant_id) ===
            Number(variantId) &&
          item.properties &&
          item.properties
            ._bundle_promo_gift ===
            promo.name
        );
      }
    );
  }

  function getPromoGiftQuantity(
    cart,
    promo,
    variantId
  ) {
    return getPromoGiftLines(
      cart,
      promo,
      variantId
    ).reduce(
      function (
        quantity,
        item
      ) {
        return (
          quantity +
          item.quantity
        );
      },
      0
    );
  }

  function getTriggerQuantity(
    cart,
    promo
  ) {
    if (
      !Array.isArray(
        promo.triggerProductHandles
      )
    ) {
      return 0;
    }

    return cart.items.reduce(
      function (
        quantity,
        item
      ) {
        if (
          promo.triggerProductHandles.indexOf(
            item.handle
          ) === -1
        ) {
          return quantity;
        }

        return (
          quantity +
          item.quantity
        );
      },
      0
    );
  }

  function shouldSyncGiftVariant(
    promo,
    cart,
    variantId
  ) {
    var exclusions =
      Array.isArray(
        promo.giftVariantExclusions
      )
        ? promo.giftVariantExclusions
        : [];

    return !exclusions.some(
      function (exclusion) {
        return (
          Number(
            exclusion.variantId
          ) ===
            Number(variantId) &&
          cartHasAnyHandle(
            cart,
            exclusion
              .whenTriggerHandlesInCart ||
              []
          )
        );
      }
    );
  }

  function cartHasActiveTriggerProduct(
    cart
  ) {
    return PROMOS.some(
      function (promo) {
        if (
          !isActivePromo(promo)
        ) {
          return false;
        }

        return cartHasAnyHandle(
          cart,
          promo.triggerProductHandles ||
            []
        );
      }
    );
  }

  function rememberManuallyRemovedGifts(
    previousCart,
    currentCart
  ) {
    if (
      !previousCart ||
      !cartHasActiveTriggerProduct(
        currentCart
      )
    ) {
      return;
    }

    getAutoGiftLines(
      previousCart
    ).forEach(function (item) {
      var promoName =
        item.properties &&
        item.properties
          ._bundle_promo_gift;

      var stillExists =
        currentCart.items.some(
          function (currentItem) {
            return (
              Number(
                currentItem.variant_id
              ) ===
                Number(
                  item.variant_id
                ) &&
              currentItem.properties &&
              currentItem.properties
                ._bundle_promo_gift ===
                promoName
            );
          }
        );

      if (!stillExists) {
        dismissGiftVariant(
          item.variant_id
        );
      }
    });
  }

  function publishCartUpdate(cart) {
    if (
      typeof publish ===
        'function' &&
      typeof PUB_SUB_EVENTS !==
        'undefined'
    ) {
      publish(
        PUB_SUB_EVENTS.cartUpdate,
        {
          source:
            'bundle-promo-gifts',
          cartData: cart,
        }
      );
    }
  }

  function postCartAdd(items) {
    if (!items.length) {
      return Promise.resolve(
        null
      );
    }

    return fetch(
      (window.routes &&
        window.routes
          .cart_add_url) ||
        '/cart/add.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json',

          'X-Requested-With':
            'XMLHttpRequest',
        },

        body: JSON.stringify({
          items: items,
        }),
      }
    );
  }

  function postCartUpdate(updates) {
    if (
      !Object.keys(updates)
        .length
    ) {
      return Promise.resolve(
        null
      );
    }

    return fetch(
      (window.routes &&
        window.routes
          .cart_update_url) ||
        '/cart/update.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json',

          'X-Requested-With':
            'XMLHttpRequest',
        },

        body: JSON.stringify({
          updates: updates,
        }),
      }
    );
  }

  function fetchCart() {
    return fetch(
      '/cart.js',
      {
        headers: {
          Accept:
            'application/json',

          'X-Requested-With':
            'XMLHttpRequest',
        },
      }
    ).then(
      function (response) {
        return response.json();
      }
    );
  }

  function getLineUnitPrice(
    line
  ) {
    if (
      !line.quantity ||
      line.quantity < 1
    ) {
      return Infinity;
    }

    return (
      Number(
        line.final_line_price
      ) / line.quantity
    );
  }

  function reducePromoGiftQuantity(
    lines,
    desiredQuantity,
    updates
  ) {
    var remaining =
      desiredQuantity;

    var sortedLines =
      lines
        .slice()
        .sort(
          function (a, b) {
            return (
              getLineUnitPrice(a) -
              getLineUnitPrice(b)
            );
          }
        );

    sortedLines.forEach(
      function (line) {
        var keepQuantity =
          Math.min(
            line.quantity,
            remaining
          );

        remaining -=
          keepQuantity;

        if (
          keepQuantity !==
          line.quantity
        ) {
          updates[line.key] =
            keepQuantity;
        }
      }
    );
  }

  function syncGiftVariants(
    promo,
    cart,
    options,
    previousCart
  ) {
    options = options || {};

    var dismissedGiftVariantIds =
      getDismissedGiftVariantIds();

    var triggerQuantity =
      getTriggerQuantity(
        cart,
        promo
      );

    var previousTriggerQuantity =
      previousCart
        ? getTriggerQuantity(
            previousCart,
            promo
          )
        : null;

    var updates = {};
    var itemsToAdd = [];

    var giftVariantIds =
      Array.isArray(
        promo.giftVariantIds
      )
        ? promo.giftVariantIds
        : [];

    giftVariantIds.forEach(
      function (variantId) {
        variantId =
          Number(variantId);

        if (!variantId) {
          return;
        }

        if (
          dismissedGiftVariantIds.indexOf(
            variantId
          ) !== -1
        ) {
          return;
        }

        var promoLines =
          getPromoGiftLines(
            cart,
            promo,
            variantId
          );

        var promoQuantity =
          promoLines.reduce(
            function (
              quantity,
              line
            ) {
              return (
                quantity +
                line.quantity
              );
            },
            0
          );

        var previousPromoQuantity =
          previousCart
            ? getPromoGiftQuantity(
                previousCart,
                promo,
                variantId
              )
            : null;

        if (
          !shouldSyncGiftVariant(
            promo,
            cart,
            variantId
          )
        ) {
          promoLines.forEach(
            function (line) {
              updates[line.key] =
                0;
            }
          );

          return;
        }

        var desiredPromoQuantity =
          triggerQuantity;

        if (
          promoQuantity >
          desiredPromoQuantity
        ) {
          var paidExtraQuantity =
            0;

          if (
            previousCart &&
            previousTriggerQuantity ===
              triggerQuantity &&
            promoQuantity >
              previousPromoQuantity
          ) {
            paidExtraQuantity =
              promoQuantity -
              Math.max(
                previousPromoQuantity,
                desiredPromoQuantity
              );
          }

          reducePromoGiftQuantity(
            promoLines,
            desiredPromoQuantity,
            updates
          );

          if (
            paidExtraQuantity > 0
          ) {
            itemsToAdd.push({
              id: variantId,
              quantity:
                paidExtraQuantity,
            });
          }

          return;
        }

        if (
          promoQuantity <
          desiredPromoQuantity
        ) {
          var missingQuantity =
            desiredPromoQuantity -
            promoQuantity;

          var triggerQuantityIncreased =
            previousCart &&
            previousTriggerQuantity !==
              null &&
            triggerQuantity >
              previousTriggerQuantity;

          var shouldAddMissingGift =
            options.addNewGifts !==
              false ||
            triggerQuantityIncreased;

          if (
            shouldAddMissingGift
          ) {
            itemsToAdd.push({
              id: variantId,

              quantity:
                missingQuantity,

              properties: {
                _bundle_promo_gift:
                  promo.name,
              },
            });
          }

          return;
        }
      }
    );

    if (
      !itemsToAdd.length &&
      !Object.keys(updates)
        .length
    ) {
      return Promise.resolve(
        cart
      );
    }

    return postCartUpdate(
      updates
    )
      .then(function () {
        return postCartAdd(
          itemsToAdd
        );
      })
      .then(function () {
        return fetchCart();
      });
  }

  function removeAutoGiftLines(
    cart
  ) {
    var giftLines =
      getAutoGiftLines(cart);

    if (!giftLines.length) {
      return Promise.resolve(
        cart
      );
    }

    var updates = {};

    giftLines.forEach(
      function (item) {
        updates[item.key] =
          0;
      }
    );

    return postCartUpdate(
      updates
    ).then(function () {
      return fetchCart();
    });
  }

  function removeInactiveAutoGiftLines(
    cart,
    activePromos
  ) {
    var activePromoNames =
      activePromos.map(
        function (promo) {
          return promo.name;
        }
      );

    var giftLines =
      getAutoGiftLines(
        cart
      ).filter(
        function (item) {
          return (
            activePromoNames.indexOf(
              item.properties
                ._bundle_promo_gift
            ) === -1
          );
        }
      );

    if (!giftLines.length) {
      return Promise.resolve(
        cart
      );
    }

    var updates = {};

    giftLines.forEach(
      function (item) {
        updates[item.key] =
          0;
      }
    );

    return postCartUpdate(
      updates
    ).then(function () {
      return fetchCart();
    });
  }

  function reconcileGifts(
    options
  ) {
    options = options || {};

    if (isReconciling) {
      return Promise.resolve();
    }

    isReconciling = true;

    var previousCart =
      lastCart;

    return fetchCart()
      .then(function (cart) {
        rememberManuallyRemovedGifts(
          previousCart,
          cart
        );

        var activePromos =
          getActivePromos(cart);

        if (
          !activePromos.length
        ) {
          clearDismissedGiftVariants();

          return removeAutoGiftLines(
            cart
          );
        }

        return removeInactiveAutoGiftLines(
          cart,
          activePromos
        ).then(
          function (
            updatedCart
          ) {
            return activePromos.reduce(
              function (
                chain,
                promo
              ) {
                return chain.then(
                  function (
                    currentCart
                  ) {
                    return syncGiftVariants(
                      promo,
                      currentCart,
                      {
                        addNewGifts:
                          options
                            .addMissingGifts !==
                          false,
                      },
                      previousCart
                    );
                  }
                );
              },

              Promise.resolve(
                updatedCart
              )
            );
          }
        );
      })
      .then(function (cart) {
        if (cart) {
          lastCart = cart;

          publishCartUpdate(
            cart
          );
        }
      })
      .catch(function (error) {
        console.error(
          '[Bundle Promo Gifts] Reconciliation failed.',
          error
        );
      })
      .finally(function () {
        isReconciling =
          false;
      });
  }

  function scheduleReconcile(
    options
  ) {
    window.clearTimeout(
      reconcileTimer
    );

    reconcileTimer =
      window.setTimeout(
        function () {
          reconcileGifts(
            options
          );
        },
        150
      );
  }

  function getCartMutationType(
    url
  ) {
    url = String(
      url || ''
    );

    if (
      url.indexOf(
        '/cart/add'
      ) !== -1
    ) {
      return 'add';
    }

    if (
      url.indexOf(
        '/cart/change'
      ) !== -1 ||
      url.indexOf(
        '/cart/update'
      ) !== -1
    ) {
      return 'change';
    }

    return null;
  }

  var originalFetch =
    window.fetch;

  window.fetch =
    function () {
      var request =
        arguments[0];

      var url =
        typeof request ===
        'string'
          ? request
          : request &&
            request.url;

      return originalFetch
        .apply(
          this,
          arguments
        )
        .then(
          function (
            response
          ) {
            var mutationType =
              getCartMutationType(
                url
              );

            if (
              !isReconciling &&
              mutationType ===
                'add'
            ) {
              scheduleReconcile({
                addMissingGifts:
                  true,
              });
            }

            if (
              !isReconciling &&
              mutationType ===
                'change'
            ) {
              scheduleReconcile({
                addMissingGifts:
                  false,
              });
            }

            return response;
          }
        );
    };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scheduleReconcile({
          addMissingGifts: true,
        });
      }
    );
  } else {
    scheduleReconcile({
      addMissingGifts: true,
    });
  }
})();